import { render, staticRenderFns } from "./_base-menu.vue?vue&type=template&id=85d3b88e"
import script from "./_base-menu.vue?vue&type=script&lang=js"
export * from "./_base-menu.vue?vue&type=script&lang=js"
import style0 from "./_base-menu.vue?vue&type=style&index=0&id=85d3b88e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports